module.exports = __webpack_public_path__ + "static/media/algorithms.77701fdc.png";